export const toUploadProfileImage = file => {
	var data = new FormData();
	data.append("image", file);
    return data;
}